import ClearPrimaryFilter from './ClearPrimaryFilter';
import CompareToPreviousPeriod from './CompareToPreviousPeriod';
import Equalize from './Equalize';
import Favorite from './Favorite';

export { cloneFilterInputActions, cloneFilterActions } from './utils';

export default {
  ClearPrimaryFilter,
  CompareToPreviousPeriod,
  Equalize,
  Favorite,
};
